import { Place } from '../company/Place';
import { RecordBase } from '../sets/RecordBase';

export abstract class DataFormat {
    public abstract getTypeName(): string;
    public abstract filterByPlace(dataSets: Record<number, RecordBase[]>, place: string): Record<number, RecordBase[]>;
    public abstract processDataSets(dataSets: Record<number, RecordBase[]>, place: Place): Record<number, RecordBase[]>;
}
